import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MeetingPersonsComponent } from '@app/meetings/views/meeting-persons/meeting-persons.component';
import { MeetingsViewComponent } from '@app/meetings/views/meetings/meetings.component';

import {
  ProjectsComponent,
  TasksComponent,
} from './views';


const routes: Routes = [
  { path: '',
    pathMatch: 'full',
    component: ProjectsComponent,
  },
  { path: 'tasks', component: TasksComponent },
  { path: 'meetings', component: MeetingsViewComponent },
  { path: 'meeting-persons', component: MeetingPersonsComponent },
  {
    path: '',
    loadChildren: () => import('./modules/plans').then((m) => m.PlansModule),
  },
  { 
    path: '',
    loadChildren: () => import('./modules/project').then((m) => m.ProjectModule),
    data: { fsNav: { root: false } },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectsRoutingModule { }
